import type { Passbook } from '@/shared/types';

/** Selos, pontos ou cashback: a mecânica vem do programa da loja. */
export function surveyBonusUnit(passbook?: Pick<Passbook, 'hasPoints' | 'hasCashback' | 'regraCartao'>): {
  label: string;
  hint: string;
} {
  const tipo = passbook?.regraCartao?.tipo?.toLowerCase();
  if (tipo === 'cashback' || passbook?.hasCashback) {
    return { label: 'Cashback a bonificar (R$)', hint: 'Valor em reais creditado a quem responder.' };
  }
  if (tipo === 'pontos' || passbook?.hasPoints) {
    return { label: 'Pontos a bonificar', hint: 'Pontos creditados a quem responder.' };
  }
  return { label: 'Selos a bonificar', hint: 'Selos creditados a quem responder.' };
}

/** "2,5" → 2.5; vazio/inválido/negativo → 0 (não bonifica). */
export function parseBonusQuantity(raw: string): number {
  const n = Number(raw.trim().replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : 0;
}
